import { IconButton, InputAdornment } from '@mui/material'
import { Close } from '@mui/icons-material'
import React from 'react'
const AutoCompleteClear = action => {
  return (
    <InputAdornment position="start">
      <IconButton sx={{ marginBottom: '3px' }} onClick={() => action()}>
        <Close color="white" />
      </IconButton>
    </InputAdornment>
  )
}

export default AutoCompleteClear
